module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/yellow-v-40cd906e1a3d1960e6e958600d97a1f6.png";